import store from '@/store'
import VueSocketIOExt from 'vue-socket.io-extended'
import { debounce } from 'lodash'
import { io } from 'socket.io-client'
import router from '@/router'
import { API_STATES } from '@/helpers'

const options = {
  autoConnect : false,
  query       : { token : null }
}

const openSocketConnection = debounce(function (userId)  {
  let resyncMessages = false
  
  this.$socket.client.io.opts.query.token = this.$store.state.app.accessToken

  if(router.history.current.path !== '/chat'){
    this.$socket.client.open()   
  }else {
    let maxInterval = 30
    const interval = setInterval(() => {
      maxInterval-=1
      if(this.$store.state.chatMessenger.conversationsGetState === API_STATES.REQUEST_SUCCESS){
        clearInterval(interval)
        this.$socket.client.open()    
      }else if(this.$store.state.chatMessenger.conversationsGetState === API_STATES.REQUEST_ERROR || maxInterval < 0){
        clearInterval(interval)
      }
    },1000)

  }
  
  this.$socket.client.on('connect', () => {
    if(resyncMessages) {
      this.$store.dispatch('chatMessenger/internetConnected')
    }
    
    this.$socket.client.emit('userConnected', { 
      userId, 
      resyncMessages, 
      lastMessageReceivedId : this.$store.state.chatMessenger.lastMessageReceivedId
    })
    resyncMessages = true
  })
}, 1000)

export default class {
  static install (Vue) {
    if(process.env.NODE_ENV !== 'development') {
      Vue.use(VueSocketIOExt, io(process.env.VUE_APP_SP_TALK_API_URL, options), { store })

      Vue.mixin({
        watch : {
          '$store.state.app.User.id'(userId) {
            if(userId){
              openSocketConnection.bind(this)(userId)
            }
          }
        }
      })
    }
  }
}

 